<template >
    <modal :show="show" v-if="isValid('CanAddProduct') || isValid('CanEditProduct')" >
        <div style="margin-bottom:0px" class="card" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header" v-if="type=='Edit'">
                            <h5 class="modal-title DayHeading " id="myModalLabel"> {{ $t('AddProductMaster.UpdateProductMaster') }}</h5>
                        </div>
                        <div class="modal-header" v-else>
                            <h5 class="modal-title DayHeading" id="myModalLabel"> {{ $t('AddProductMaster.AddProductMaster') }}</h5>
                        </div>
                        <div class="">
                            <div class="card-body" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <div class="row ">
                                    <div :key="render" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.productMaster.code.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddProductMaster.Code') }}:<span class="LabelColour"> *</span></label>
                                        <input disabled class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.productMaster.code.$model" type="text" />
                                        <span v-if="$v.productMaster.code.$error" class="error">
                                            <span v-if="!$v.productMaster.code.maxLength">{{ $t('AddProductMaster.CodeLength') }}</span>
                                        </span>
                                    </div>
                                    <div v-if="english=='true'" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.productMaster.name.$error}">
                                        <label class="text  font-weight-bolder"> {{$t('AddProductMaster.ProductMasterName') |englishLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.productMaster.name.$model" type="text" />
                                        <span v-if="$v.productMaster.name.$error" class="error">
                                            <span v-if="!$v.productMaster.name.required"> {{ $t('AddProductMaster.NameRequired') }}</span>
                                            <span v-if="!$v.productMaster.name.maxLength">{{ $t('AddProductMaster.NameLength') }}</span>
                                        </span>
                                    </div>
                                    <div v-if="isOtherLang()" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.productMaster.nameArabic.$error}">
                                        <label class="text  font-weight-bolder">{{ $t('AddProductMaster.ProductMasterName') |arabicLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control "  v-bind:class="isLeftToRight() ? 'text-left' : 'arabicLanguage'"  v-model="$v.productMaster.nameArabic.$model" type="text" />
                                        <span v-if="$v.productMaster.nameArabic.$error" class="error">
                                            <span v-if="!$v.productMaster.nameArabic.required"> {{ $t('AddProductMaster.NameRequired') }}</span>
                                            <span v-if="!$v.productMaster.nameArabic.maxLength">{{ $t('AddProductMaster.NameLength') }}</span>
                                        </span>
                                    </div>

                                    <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.productMaster.description.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddProductMaster.Description') }}: </label>
                                        <textarea class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.productMaster.description.$model" type="text" />
                                        <span v-if="$v.productMaster.description.$error" class="error">{{ $t('AddProductMaster.descriptionLength') }}</span>
                                    </div>
                                    <div class="form-group col-md-12">
                                        <label class="ml-2 mr-2">{{ $t('AddProductMaster.Active') }}</label>
                                        <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': productMaster.isActive, 'bootstrap-switch-off': !productMaster.isActive}" v-on:click="productMaster.isActive = !productMaster.isActive" style="width: 72px;">
                                            <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                                <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-check-2"></i>
                                                </span>
                                                <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                                <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-simple-remove"></i>
                                                </span>
                                                <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-color="success" data-off-color="success">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!loading">
                            <div class="modal-footer justify-content-right" v-if="type=='Edit'">
                                <button type="button" class="btn btn-success  " v-on:click="SaveProductMaster" v-bind:disabled="$v.productMaster.$invalid"  v-if=" isValid('CanEditProduct') "> {{ $t('AddProductMaster.btnUpdate') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('AddProductMaster.btnClear') }}</button>
                            </div>
                            <div class="modal-footer justify-content-right" v-if="type!='Edit'">
                                <button type="button" class="btn btn-success  " v-on:click="SaveProductMaster" v-bind:disabled="$v.productMaster.$invalid"  v-if=" isValid('CanAddProduct') "> {{ $t('AddProductMaster.btnSave') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('AddProductMaster.btnClear') }}</button>
                            </div>
                        </div>
                        <div v-else>
                            <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
    <acessdenied v-else :model=true></acessdenied>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { maxLength, requiredIf } from "vuelidate/lib/validators"
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        mixins: [clickMixin],
        props: ['show', 'productMaster', 'type'],
        components: {
            Loading
        },
        data: function () {
            return {
                arabic: '',
                english: '',
                render: 0,
                loading: false,
                isMasterProduct: false,
            }
        },
        validations: {
            productMaster: {
                name: {
                    maxLength: maxLength(250)
                },
                code: {
                    maxLength: maxLength(30)
                },
                nameArabic: {
                    required: requiredIf((x) => {
                        if (x.name == '' || x.name == null)
                            return true;
                        return false;
                    }),
                    maxLength: maxLength(250)
                },
                description: {
                    maxLength: maxLength(500)
                }
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            GetAutoCodeGenerator: function () {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Product/ProductMasterCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        root.productMaster.code = response.data;
                        root.render++;
                    }
                });
            },
            SaveProductMaster: function () {
                var root = this;
                this.loading = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.post('/Product/SaveProductMaster', this.productMaster, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isSuccess == true) {
                            if (root.type != "Edit") {

                                root.$swal({
                                    title: "Saved!",
                                    text: "Saved Successfully!",
                                    type: 'success',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });

                                root.close();
                            }
                            else {

                                root.$swal({
                                    title: "Update!",
                                    text: "Update Successfully!",
                                    type: 'success',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });
                                root.close();

                            }
                        }
                        else {
                            root.$swal({
                                title: "Error!",
                                text: "Your ProductMaster Name  Already Exist!",
                                type: 'error',
                                icon: 'error',
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error.response.data,

                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false);
            }
        },
        mounted: function () {
            this.isMasterProduct = localStorage.getItem('IsMasterProductPermission') == 'true' ? true : false;

            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            if (this.productMaster.id == '00000000-0000-0000-0000-000000000000' || this.productMaster.id == undefined || this.productMaster.id == '')
                this.GetAutoCodeGenerator();

        }
    }
</script>
